// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"90":"2ee3b47b","154":"4b046d01","604":"7c35a1b1","805":"2d283270","960":"72bb842e","991":"d9dc0f6a"}[chunkId] + ".chunk.js";
};